import { useMutation } from '@tanstack/react-query'
import { api } from '@api'

interface StartSocialImportData {
  network: 'instagram' | 'facebook' | 'twitter' | 'linkedin'
  username: string
}

interface StartSocialImportResponse {
  importId: string
}

const startSocialImport = async (data: StartSocialImportData): Promise<StartSocialImportResponse> => {
  const { data: response } = await api.post<StartSocialImportResponse>('/ft_import-contacts/start', data)
  return response
}

export const useFtStartSocialImport = () => {
  return useMutation<StartSocialImportResponse, Error, StartSocialImportData>({
    mutationFn: startSocialImport,
  })
}
